import React, { useState, useContext, useEffect } from 'react'
import { get, isEmpty } from 'lodash'
import {
  Form,
  Row,
  Col,
  Label,
  FormGroup,
  Input,
  Button
} from 'reactstrap'

import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { loginSuccess } from "../store/actions"
import { GeneralContext } from '../context/'
import ApiService from '../data/services/ApiService'

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

const VerifyForm = (props) => {
  const generalContext = useContext(GeneralContext)
  const { loading, setLoading } = generalContext

  const userId = get(props, 'match.params.userId', false)
  const code = get(props, 'location.search', '').replace('?code=', '')

  // Confirmation
  const [verificationCode, setVerificationCode] = useState('')

  useEffect(() => {
    setVerificationCode(code)
  }, [code])

  const _handleConfirmCode = async (e) => {
    try {
      e.preventDefault()
      setLoading(true)
      if (verificationCode === '') { 
        toastr.error('No te olvides de escribir el código que te enviamos por SMS', '')
        return
      }

      let response = await ApiService.validateCode({
        verificationCode,
        id: userId
      })

      if (!response.data.success) {
        toastr.error('El código que utilizaste es incorrecto.', 'Problemas')

        setVerificationCode('')
        document.getElementById('verificationCode').focus()

        return
      }

      if (!response.data.waitingList) {
        toastr.success('Ya eres una vendora', '¡Bienvenida!')

        // @todo: sign in user
        localStorage.setItem('authToken', response.data.token)
        localStorage.setItem('authUser', JSON.stringify(response.data.user))

        props.loginSuccess(response.data.user)
        props.history.push('/dashboard')
      } else {
        props.history.push('/confirmacion')
      }
    } catch(error) {
      toastr.error('Error al validar código', 'Error')
    } finally {
      setLoading(false)
    }
  }

  const _resendCode = async () => {
    setLoading(true)
    await ApiService.resendCode({ id: userId })
    toastr.success('Ya te envié el código de nuevo.', '')
    setLoading(false)
  }

  const _renderConfirmCode = () => {
    return (
      <Form id="confirm-code" method="POST" onSubmit={ _handleConfirmCode }>
        <h1>Confirma tu cuenta</h1>

        <h2>Te hemos enviado un código por SMS, escríbelo para continuar.</h2>

        <Row>
          <Col sm={12}>
            <FormGroup>
              <Label>
                Código de Verificación
              </Label>
              <Input
                required
                type="number"
                pattern="[0-9]*"
                inputmode="numeric"
                maxLength="5"
                autocomplete="one-time-code"
                id="verificationCode"
                className="form-control"
                value={verificationCode}
                onChange={event => setVerificationCode(event.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            ¿No te llegó? <Button onClick={ () => { _resendCode() } }>Reenviar código</Button>
          </Col>
        </Row>

        <Row className="form-actions" style={{ marginTop: '10px' }}>
          <Button
            type="submit"
            disabled={loading || isEmpty(verificationCode)}
            className="btn btn-primary btn-block waves-effect waves-light"
          >
            Confirmar Cuenta
          </Button>
        </Row>
      </Form>
    )
  }

  return (
    <React.Fragment>
      {_renderConfirmCode()}
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  return state
}

export default withRouter(
  connect(mapStatetoProps, { loginSuccess })(VerifyForm)
)